import { GenericActionWithPayload, GenericAction } from "./action-types";
import { AuthenticationStateType } from "./state-types";

type Aggregator = {
  code: string;
  name: string;
  image: string;
};

type TranslationSet = {
  [x: string]: string | TranslationSet;
};

type Config = {
  tposFilters: Filter[];
  nutritionalInformationTranslations: TranslationSet;
  featureFlags: FeatureFlags;
  aggregators: Aggregator[];
};

type ConfigAppState = {
  configState: Config;
  authentication: AuthenticationStateType;
};

type FeatureFlags = {
  enablePickupOrders: boolean;
  enableHeroSection: boolean;
  enableGroupOrdering: boolean;
  enableLaunchPopup: boolean;
  enableAsyncFlowForTpos?: boolean;
  enableCombosForTpos?: boolean;
};

type ConfigState = {
  config: Config;
  selectedFilter?: string;
};

type Filter = {
  category: string;
  name: {
    ar: string;
    en: string;
  };
};

type ConfigAction =
  | GenericActionWithPayload<"CONFIG_SET", Config>
  | GenericActionWithPayload<"CHANGE_FILTER", string>
  | GenericAction<"CONFIG_FETCH">;

export type {
  Config,
  ConfigState,
  Filter,
  Aggregator,
  TranslationSet,
  ConfigAppState,
  ConfigAction,
};
